/**
 * Central route paths. All `navigate(...)` calls and `<Route path=...>` use
 * these constants so renaming a route is a one-line change.
 */

export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  SIGNUP: "/signup",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  /** Where an account-invite magic link lands. Carries ?token=. */
  ACTIVATE: "/activate",
  /** Where an emailed sign-in link lands. Carries ?token=. */
  MAGIC_LINK: "/magic-link",
  /** "Manage your emails" from an email footer. Carries ?token=, no sign in. */
  EMAIL_PREFERENCES: "/email-preferences",
  CHANGE_PASSWORD: "/change-password",
  DASHBOARD: "/",
  /** Where the "Set up your account" link lands. Carries ?token=, or none
   *  for a signed-in parent who still has to add a child. */
  ONBOARDING: "/onboarding",
  /** Public slot picker from the "Choose a time" email. Carries ?token=. */
  BOOK_ASSESSMENT: "/book-assessment",
  /** Retired booking forms. Both redirect to the /learn form on the website. */
  APPLY: "/apply",
  REGISTER: "/register",

  // Phase 7 destinations. Declared so the Dashboard's KPI tiles and quick
  // actions can navigate. Pages mount in App.tsx as they land; clicks to
  // not-yet-mounted routes resolve via the catch-all back to the dashboard.
  STUDENTS: "/students",
  TUTORS: "/tutors",
  LESSONS: "/lessons",
  HOMEWORK: "/homework",
  SUBMISSIONS: "/submissions",
  RESOURCES: "/resources",
  MESSAGES: "/messages",
  PROGRESS: "/progress",
  REPORTS: "/reports",
  BILLING: "/billing",
  PIPELINE: "/pipeline",
  BOOKINGS: "/bookings",
  CAREERS: "/careers",
  SETTINGS: "/settings",
  /** Settings sections (TL-060 to TL-063). `/settings` opens the first one the person can see. */
  SETTINGS_BRANDING: "/settings/branding",
  SETTINGS_SUBSCRIPTION: "/settings/subscription",
  /** Stripe Connect returns here with ?connected=1 (14-API-CONTRACT). */
  SETTINGS_PAYMENTS: "/settings/payments",
  SETTINGS_DOMAIN: "/settings/domain",
  SETTINGS_CONNECTIONS: "/settings/connections",
  /** TL-064 First-run setup for a new institute's owner. */
  SETUP: "/setup",
  PROFILE: "/profile",
  DATA_CONTROL: "/data-control",
  AVAILABILITY: "/availability",
  /** What's new and improved, filtered to each role. Every role. */
  WHATS_NEW: "/whats-new",
  /** Help queries: your own (admins: everyone's). Every role. */
  CHANGELOG: "/changelog",
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
